<div (click)="closeDropdowns()" class="min-h-screen bg-[#050508] bg-gradient-to-b from-[#050508] via-[#0b0b13] to-[#050508] text-[#e0e0e9] font-sans relative overflow-hidden pb-24 select-none">
  
  <!-- Glowing background elements -->
  <div class="absolute top-0 left-1/4 w-[500px] h-[500px] bg-gold/5 rounded-full blur-[120px] pointer-events-none"></div>
  <div class="absolute top-1/3 right-1/4 w-[600px] h-[600px] bg-[#8247E5]/5 rounded-full blur-[140px] pointer-events-none"></div>
  <div class="absolute bottom-10 left-10 w-[400px] h-[400px] bg-gold/5 rounded-full blur-[100px] pointer-events-none"></div>

  <!-- Custom Navigation Header -->
  <header class="border-b border-white/[0.06] bg-[#050508]/80 backdrop-blur-md sticky top-0 z-50">
    <div class="max-w-[1320px] mx-auto px-4 sm:px-6 lg:px-10 py-3.5 sm:py-5 flex items-center justify-between gap-3">
      
      <!-- Brand Logo -->
      <div (click)="launchDex()" class="flex items-center gap-2.5 sm:gap-3 shrink-0 cursor-pointer group select-none">
        <div class="relative flex items-center justify-center shrink-0">
          <div class="absolute -inset-1 bg-gold/20 rounded-full blur-md animate-pulse"></div>
          <img src="/logo.png" alt="DEX" class="h-7 sm:h-8 w-auto object-contain shrink-0 relative z-10 group-hover:scale-105 transition-transform duration-300 block" />
        </div>
        <span class="font-display font-black text-[22px] sm:text-[26px] leading-none tracking-widest text-white uppercase group-hover:text-gold transition-colors duration-300 hidden sm:inline-flex items-center translate-y-[0.5px]">
          DEX
        </span>
      </div>

      <!-- Desktop & Mobile Control Panel -->
      <div class="flex items-center gap-1.5 sm:gap-3 justify-end shrink-0">
        
        <!-- LAUNCH DEX (Visible on both Mobile and Desktop) -->
        <button (click)="launchDex()" 
          class="px-3.5 sm:px-5 h-[36px] sm:h-[42px] rounded-lg sm:rounded-xl border border-gold/30 bg-gold/5 text-gold hover:border-gold hover:bg-gold/10 shadow-[0_0_15px_rgba(212,175,55,0.08)] text-[11px] sm:text-[12.5px] font-bold uppercase tracking-wider transition-all duration-300 flex items-center justify-center shrink-0">
          LAUNCH DEX
        </button>

        <!-- Desktop-Only Menus (EARN PASSIVE and EARN AGGRESSIVE) -->
        <div class="hidden md:flex items-center gap-3">
          <!-- Earn Passive Dropdown Wrapper -->
          <div class="relative">
            <button (click)="togglePassiveDropdown($event)" 
              class="px-5 h-[42px] rounded-xl border border-gold/30 bg-gold/5 text-gold hover:border-gold hover:bg-gold/10 shadow-[0_0_15px_rgba(212,175,55,0.08)] text-[12.5px] font-bold uppercase tracking-wider transition-all duration-300 flex items-center justify-center gap-1.5">
              EARN PASSIVE
              <svg class="w-3.5 h-3.5 transition-transform duration-300" [ngClass]="{'rotate-180': passiveDropdownOpen}" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
              </svg>
            </button>

            <!-- Dropdown List -->
            @if (passiveDropdownOpen) {
              <div (click)="$event.stopPropagation()" 
                class="absolute right-0 mt-2 w-48 bg-[#0b0b12] border border-white/[0.08] rounded-xl shadow-[0_10px_25px_rgba(0,0,0,0.5)] py-1.5 z-50 animate-in fade-in slide-in-from-top-2 duration-200">
                <button (click)="navigateToPassive()" class="w-full text-center px-4 py-2.5 text-[11.5px] text-text-muted hover:text-white hover:bg-white/[0.03] transition-colors font-semibold uppercase tracking-wider">
                  Staking
                </button>
                <button (click)="navigateToYieldFarming()" class="w-full text-center px-4 py-2.5 text-[11.5px] text-text-muted hover:text-white hover:bg-white/[0.03] transition-colors font-semibold uppercase tracking-wider">
                  Yield Farming
                </button>
              </div>
            }
          </div>

          <button (click)="navigateToAggressive()" 
            class="px-5 h-[42px] rounded-xl border border-gold/30 bg-gold/5 text-gold hover:border-gold hover:bg-gold/10 shadow-[0_0_15px_rgba(212,175,55,0.08)] text-[12.5px] font-bold uppercase tracking-wider transition-all duration-300 flex items-center justify-center">
            EARN AGGRESSIVE
          </button>
        </div>

        <!-- Mobile Menu Toggle Button (3 bars / Close) -->
        <button (click)="toggleMobileMenu($event)" class="md:hidden text-white hover:text-gold transition-colors p-1.5 focus:outline-none shrink-0">
          <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            @if (mobileMenuOpen) {
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            } @else {
              <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            }
          </svg>
        </button>

      </div>

    </div>

    <!-- Mobile Navigation Menu -->
    @if (mobileMenuOpen) {
      <div (click)="$event.stopPropagation()" 
        class="md:hidden absolute top-[100%] left-0 right-0 bg-[#050508]/95 backdrop-blur-xl border-b border-white/[0.06] flex flex-col p-4 gap-3.5 z-40 shadow-2xl animate-in fade-in slide-in-from-top-2 duration-200">
        
        <!-- Passive Options -->
        <div class="flex flex-col gap-1.5">
          <button (click)="mobilePassiveOpen = !mobilePassiveOpen" 
            class="w-full px-3.5 py-2.5 rounded-lg border border-gold/30 bg-gold/5 text-gold text-[12px] font-bold uppercase tracking-wider flex items-center justify-center gap-1.5 transition-colors">
            <span>EARN PASSIVE</span>
            <svg class="w-3.5 h-3.5 transition-transform duration-300" [ngClass]="{'rotate-180': mobilePassiveOpen}" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          
          <!-- Mobile Passive Dropdown Links -->
          @if (mobilePassiveOpen) {
            <div class="flex flex-col gap-1.5 mt-1 animate-in fade-in slide-in-from-top-1 duration-200">
              <button (click)="navigateToPassive()" class="w-full text-center py-2.5 rounded-lg border border-gold/20 bg-gold/[0.02] text-gold/80 hover:text-gold hover:bg-gold/10 text-[12px] font-bold uppercase tracking-wider transition-colors font-mono">
                Staking
              </button>
              <button (click)="navigateToYieldFarming()" class="w-full text-center py-2.5 rounded-lg border border-gold/20 bg-gold/[0.02] text-gold/80 hover:text-gold hover:bg-gold/10 text-[12px] font-bold uppercase tracking-wider transition-colors font-mono">
                Yield Farming
              </button>
            </div>
          }
        </div>

        <button (click)="navigateToAggressive()" class="w-full text-center py-2.5 rounded-lg border border-gold/30 bg-gold/5 text-gold text-[12px] font-bold uppercase tracking-wider transition-colors border-t border-gold/20 pt-3 mt-1">
          EARN AGGRESSIVE
        </button>
      </div>
    }
  </header>

  <!-- Main Document Container -->
  <main class="max-w-[1320px] mx-auto px-6 lg:px-10 pt-8 space-y-8 relative z-10">

    <!-- 1. THE FEED -->
    <section class="grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
      
      <!-- Feed Visual Mockup -->
      <div class="relative flex items-center justify-center p-4">
        <div class="w-full max-w-[520px] rounded-2xl bg-[#0c0c0c]/90 border border-white/10 p-5 shadow-2xl backdrop-blur-xl space-y-3">
          <div class="flex items-center justify-between border-b border-white/10 pb-3">
            <div class="flex items-center gap-2">
              <span class="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"></span>
              <span class="text-xs font-black uppercase tracking-widest text-white">Live On-Chain Price Feed</span>
            </div>
            <span class="text-[10.5px] text-text-dim font-mono">Synced: Block #19824201</span>
          </div>
          <div class="space-y-2">
            <div class="p-3 rounded-xl bg-white/[0.03] border border-white/[0.06] flex items-center justify-between">
              <div class="flex items-center gap-3">
                <div class="w-8 h-8 rounded-lg bg-gold/10 text-gold font-black flex items-center justify-center text-xs">ETH</div>
                <div>
                  <div class="text-xs font-bold text-white">ETH / USDC</div>
                  <div class="text-[10px] text-text-dim">Uniswap V3 Concentrated</div>
                </div>
              </div>
              <div class="text-right">
                <div class="text-xs font-mono font-bold text-white">$3,124.50</div>
                <div class="text-[10.5px] font-mono text-emerald-400 font-bold">+2.84%</div>
              </div>
            </div>
            <div class="p-3 rounded-xl bg-white/[0.03] border border-white/[0.06] flex items-center justify-between">
              <div class="flex items-center gap-3">
                <div class="w-8 h-8 rounded-lg bg-gold/10 text-gold font-black flex items-center justify-center text-xs">BNB</div>
                <div>
                  <div class="text-xs font-bold text-white">BNB / USDT</div>
                  <div class="text-[10px] text-text-dim">PancakeSwap V3</div>
                </div>
              </div>
              <div class="text-right">
                <div class="text-xs font-mono font-bold text-white">$612.80</div>
                <div class="text-[10.5px] font-mono text-emerald-400 font-bold">+1.45%</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Feed Explanation -->
      <div class="space-y-4">
        <h2 class="font-display font-black text-[24px] md:text-[28px] text-white tracking-wide leading-tight">
          1. The Feed <span class="text-gold block md:inline">(The Market Pulse)</span>
        </h2>
        <p class="text-[15px] text-text-muted leading-relaxed">
          In traditional banking, this is the live, tick-by-tick price.
        </p>
        <p class="text-[15px] text-text-muted leading-relaxed">
          On <strong class="text-white font-medium">DEX</strong>, it's the live, on-chain price data of crypto pairs, used to execute swaps and generate fees.
        </p>
      </div>

    </section>

    <!-- 2. YOUR WALLET -->
    <section class="grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
      
      <!-- Wallet Explanation (On the left on desktop for alternating flow) -->
      <div class="space-y-4 order-2 md:order-1">
        <h2 class="font-display font-black text-[24px] md:text-[28px] text-white tracking-wide leading-tight">
          2. Your Wallet <span class="text-gold block md:inline">(Your Bank Account)</span>
        </h2>
        <p class="text-[15px] text-text-muted leading-relaxed">
          Your wallet (e.g., MetaMask) acts as your personal checking account. 
        </p>
        <p class="text-[15px] text-text-muted leading-relaxed">
          Unlike a bank, <strong class="text-white font-semibold">DEX gives you full custody</strong>. Your wallet tracks your share of the pool, not a deposit.
        </p>
      </div>

      <!-- Wallet Visual Mockup -->
      <div class="order-1 md:order-2 relative flex items-center justify-center p-4">
        <div class="w-full max-w-[520px] rounded-2xl bg-[#0c0c0c]/90 border border-white/10 p-5 shadow-2xl backdrop-blur-xl space-y-4">
          <div class="flex items-center justify-between border-b border-white/10 pb-3">
            <div class="flex items-center gap-2.5">
              <div class="w-8 h-8 rounded-full bg-gold/20 text-gold flex items-center justify-center text-xs font-black">W3</div>
              <div>
                <div class="text-xs font-bold text-white">Self-Custodial Vault</div>
                <div class="text-[10px] text-emerald-400 font-mono">100% User Owned</div>
              </div>
            </div>
            <span class="px-2.5 py-1 rounded-full text-[9px] font-bold uppercase bg-emerald-500/10 text-emerald-400 border border-emerald-500/20">Connected</span>
          </div>
          <div class="grid grid-cols-2 gap-3">
            <div class="p-3 bg-white/[0.03] rounded-xl border border-white/[0.06]">
              <div class="text-[10px] text-text-dim uppercase font-bold tracking-wider">Total Stored TVL</div>
              <div class="text-sm font-bold text-white font-mono mt-1">$48,250.00</div>
            </div>
            <div class="p-3 bg-white/[0.03] rounded-xl border border-white/[0.06]">
              <div class="text-[10px] text-text-dim uppercase font-bold tracking-wider">Unclaimed Fees</div>
              <div class="text-sm font-bold text-gold font-mono mt-1">+$312.40</div>
            </div>
          </div>
        </div>
      </div>

    </section>

    <!-- 3. THE TWO WAYS TO EARN -->
    <section class="space-y-4">
      
      <!-- Section Title -->
      <div class="text-center max-w-xl mx-auto space-y-2">
        <h2 class="font-display font-black text-[28px] md:text-[32px] text-white uppercase tracking-wider leading-none">
          The Two Ways to Earn the <span class="text-gold">"Banking Fees"</span>
        </h2>
        <div class="w-24 h-[3px] bg-gold mx-auto rounded-full"></div>
      </div>

      <!-- Strategy Columns -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-12 items-start">
        
        <!-- Strategy A: The Aggressive Route -->
        <div id="aggressive-strategy" class="border border-white/[0.08] rounded-[24px] p-6 flex flex-col justify-between h-full group hover:border-gold/30 hover:shadow-[0_10px_30px_rgba(212,175,55,0.05)] transition-all duration-500">
          <div>
            <span class="text-[11px] font-bold text-gold tracking-widest uppercase mb-1 block">STRATEGY A</span>
            <h3 class="text-[18px] md:text-[20px] font-black text-white mb-2 leading-tight">
              The Aggressive Route <span class="text-text-dim block text-[14px] font-medium">(Liquidity Provider - LP)</span>
            </h3>
            
            <!-- Graphic Illustration A Mockup -->
            <div class="my-4 p-4 rounded-xl bg-black/50 border border-gold/20 flex flex-col gap-2">
              <div class="flex justify-between items-center text-[11px] text-text-dim">
                <span>Concentrated Price Band</span>
                <span class="text-gold font-bold font-mono">In Range (Active)</span>
              </div>
              <div class="w-full h-3 bg-white/10 rounded-full overflow-hidden relative">
                <div class="absolute left-1/4 right-1/4 h-full bg-gradient-to-r from-gold via-amber-400 to-gold rounded-full animate-pulse"></div>
              </div>
              <div class="flex justify-between text-[10px] text-text-dim font-mono">
                <span>Min: $2,800</span>
                <span class="text-white font-bold">Current: $3,124</span>
                <span>Max: $3,600</span>
              </div>
            </div>

            <h4 class="text-[14px] font-bold text-white mb-1.5">Active Management</h4>
            <p class="text-[13.5px] text-text-muted leading-relaxed">
              You place your capital in specific, concentrated price ranges. Captures high daily fees when the market is within your range. Requires manual compounding daily and carries impermanent loss risk.
            </p>
          </div>
          <div class="mt-4">
            <button (click)="navigateToAggressive()" class="w-full py-3 rounded-xl border border-gold/30 hover:border-gold hover:bg-gold/5 text-gold text-[12.5px] font-bold uppercase tracking-wider transition-all duration-300">
              Provide LP Liquidity
            </button>
          </div>
        </div>

        <!-- Strategy B: The Passive Route -->
        <div id="passive-strategy" class="border border-white/[0.08] rounded-[24px] p-6 flex flex-col justify-between h-full group hover:border-[#8247E5]/30 hover:shadow-[0_10px_30px_rgba(130,71,229,0.05)] transition-all duration-500">
          <div>
            <span class="text-[11px] font-bold text-[#8247E5] tracking-widest uppercase mb-1 block">STRATEGY B</span>
            <h3 class="text-[18px] md:text-[20px] font-black text-white mb-2 leading-tight">
              The Passive Route <span class="text-text-dim block text-[14px] font-medium">(Staking & Yield Farms)</span>
            </h3>

            <!-- Graphic Illustration B Mockup -->
            <div class="my-4 p-4 rounded-xl bg-black/50 border border-[#8247E5]/25 flex flex-col gap-2">
              <div class="flex justify-between items-center text-[11px] text-text-dim">
                <span>Auto-Compounding Vault</span>
                <span class="text-purple-400 font-bold font-mono">1.5x Multiplier</span>
              </div>
              <div class="flex items-center gap-2 text-xs text-white">
                <span class="w-2 h-2 rounded-full bg-purple-400"></span>
                <span>Passive Protocol Staking & Monthly Payouts</span>
              </div>
            </div>

            <h4 class="text-[14px] font-bold text-white mb-1.5">Silent Investor</h4>
            <p class="text-[13.5px] text-text-muted leading-relaxed">
              You delegate capital to the protocol's pre-set, wide pools. Earns steady, consistent fees + DEX Governance Token. Protocol automates compounding and pays out monthly. A "set-and-forget" income stream.
            </p>
          </div>
          <div class="mt-4">
            <button (click)="navigateToPassive()" class="w-full py-3 rounded-xl border border-[#8247E5]/30 hover:border-[#8247E5] hover:bg-[#8247E5]/5 text-[#8247E5] text-[12.5px] font-bold uppercase tracking-wider transition-all duration-300">
              Go to Staking & Farms
            </button>
          </div>
        </div>

      </div>

    </section>

    <!-- 4. SUMMARY COMPARISON -->
    <section class="space-y-4">
      
      <div class="space-y-1">
        <h2 class="font-display font-black text-[22px] text-white uppercase tracking-wider">
          4. Summary Comparison
        </h2>
        <div class="w-16 h-[2px] bg-gold rounded-full"></div>
      </div>

      <!-- Comparison Table -->
      <div class="w-full overflow-x-auto rounded-2xl border border-white/[0.08] bg-[#0c0c12]/50 shadow-2xl backdrop-blur-xl">
        <table class="w-full text-left border-collapse min-w-[600px]">
          <thead>
            <tr class="border-b border-white/[0.08] bg-white/[0.02]">
              <th class="p-4 text-[12px] font-bold text-text-dim uppercase tracking-wider">Feature</th>
              <th class="p-4 text-[12px] font-bold text-gold uppercase tracking-wider">Aggressive LP (Concentrated)</th>
              <th class="p-4 text-[12px] font-bold text-[#8247E5] uppercase tracking-wider">Passive Staking (Yield Farm)</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-white/[0.04] text-[13.5px]">
            
            <!-- Row 1 -->
            <tr class="hover:bg-white/[0.01] transition-colors">
              <td class="p-4 font-bold text-white">Your Role</td>
              <td class="p-4 text-text-muted">Aggressive LP (Concentrated)</td>
              <td class="p-4 text-text-muted">Passive Staking (Yield Farm)</td>
            </tr>

            <!-- Row 2 -->
            <tr class="hover:bg-white/[0.01] transition-colors">
              <td class="p-4 font-bold text-white">Action Required</td>
              <td class="p-4 text-gold">
                <!-- Checkmark -->
                <svg class="w-5 h-5 inline" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </td>
              <td class="p-4 text-[#8247E5]">
                <svg class="w-5 h-5 inline" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </td>
            </tr>

            <!-- Row 3 -->
            <tr class="hover:bg-white/[0.01] transition-colors">
              <td class="p-4 font-bold text-white">Fee Capture</td>
              <td class="p-4 text-gold">
                <svg class="w-5 h-5 inline" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </td>
              <td class="p-4 text-[#8247E5]">
                <svg class="w-5 h-5 inline" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </td>
            </tr>

            <!-- Row 4 -->
            <tr class="hover:bg-white/[0.01] transition-colors">
              <td class="p-4 font-bold text-white">Compounding</td>
              <td class="p-4 text-text-muted">Requires manual compounding daily</td>
              <td class="p-4 text-text-muted">Passive Staking (Yield Farm)</td>
            </tr>

            <!-- Row 5 -->
            <tr class="hover:bg-white/[0.01] transition-colors">
              <td class="p-4 font-bold text-white">Extra Reward</td>
              <td class="p-4 text-gold">
                <svg class="w-5 h-5 inline" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </td>
              <td class="p-4 text-[#8247E5]">
                <svg class="w-5 h-5 inline" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </td>
            </tr>

            <!-- Row 6 -->
            <tr class="hover:bg-white/[0.01] transition-colors">
              <td class="p-4 font-bold text-white">Payout Schedule</td>
              <td class="p-4 text-gold">
                <svg class="w-5 h-5 inline" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </td>
              <td class="p-4 text-[#8247E5]">
                <svg class="w-5 h-5 inline" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </td>
            </tr>

            <!-- Row 7 -->
            <tr class="hover:bg-white/[0.01] transition-colors">
              <td class="p-4 font-bold text-white">Best For</td>
              <td class="p-4 text-text-muted">Aggressive LP (Concentrated)</td>
              <td class="p-4 text-text-muted flex items-center gap-1.5">
                <span class="w-2.5 h-2.5 rounded-full bg-gold inline-block"></span>
                DEX Governance Token
              </td>
            </tr>

          </tbody>
        </table>
      </div>

    </section>

    <!-- 5. THE FINAL VERDICT -->
    <section class="space-y-4">
      
      <div class="space-y-1">
        <h2 class="font-display font-black text-[22px] text-white uppercase tracking-wider">
          5. The Final Verdict
        </h2>
        <div class="w-16 h-[2px] bg-gold rounded-full"></div>
      </div>

      <!-- Verdict Box -->
      <div class="p-6 md:p-8 rounded-[24px] border border-gold/20 bg-gradient-to-r from-gold/[0.02] via-[#0b0b12] to-gold/[0.02] relative overflow-hidden">
        <div class="absolute -top-12 -right-12 w-32 h-32 bg-gold/5 rounded-full blur-2xl"></div>
        <p class="text-[15.5px] font-medium text-white mb-4 leading-relaxed">
          DEX Finance turns the chaotic world of DeFi into a structured banking alternative.
        </p>
        <ul class="space-y-3.5 text-[14.5px] text-text-muted">
          <li class="flex items-start gap-3">
            <span class="text-gold mt-1 shrink-0">
              <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
              </svg>
            </span>
            <span>The Feed tells you where the money is flowing. Your Wallet is your vault.</span>
          </li>
          <li class="flex items-start gap-3">
            <span class="text-gold mt-1 shrink-0">
              <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
              </svg>
            </span>
            <span>Strategy A makes you the active banker, chasing the highest yields daily.</span>
          </li>
          <li class="flex items-start gap-3">
            <span class="text-gold mt-1 shrink-0">
              <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
              </svg>
            </span>
            <span>Strategy B makes you the depositor, letting DEX's algorithm work as your fund manager, delivering your "banking fees" to you monthly like a dividend check.</span>
          </li>
        </ul>
      </div>

    </section>

  </main>

</div>
